/* eslint-disable no-unused-vars */
import { findTeeTimeByUser } from "utils/teeTime";
import { useNavigate, useParams } from "react-router-dom";
import { EventDetails } from "components/EventDetails";
import { isTeeTimeSubmitted } from "utils/match";
import { useUserData } from "hooks/useUserData";
import { useTeeTimes } from "hooks/useTeeTimes";
import { useEvent } from "hooks/useEvent";
import Text from "components/Common/Text";
import { formatFirestoreTimeStamp } from "utils";
import AlertContext from "components/Common/ModalAlert";
import { useAuth } from "hooks/useAuth";
import "./styles.css";

import { useContext } from "react";
import { ShareLink } from "components/ShareLink/ShareLink";
import { EventTeeTimesSkeleton } from "./skeleton/eventTeeTimesSkeleton";
import { CardEvent2 } from "./components/cardEvent/cardEvent2";
import { Header } from "../Common/Header";

export const check2hourGap = (targetTimestamp) => {
  const currentDate = new Date();
  const targetDate = new Date(targetTimestamp.toDate());

  const twoHoursBeforeTarget = new Date(
    targetDate.getTime() - 2 * 60 * 60 * 1000,
  );
  // if (currentDate >= twoHoursBeforeTarget && currentDate < targetDate) {
  //   return true;
  // }
  if (currentDate >= twoHoursBeforeTarget) {
    return true;
  }
  return false;
};

/* eslint-disable no-shadow */
/* eslint-disable consistent-return */

/**
 * Checks user in tee times collections
 * by firebase uid or phone number
 *
 * @param {boolean} teamsPlay bool teams or not, from root event
 * @param {Array} teeTimes array of teeTime
 * @param {string} phone phone number string
 * @returns {Array} array with FUITT property (FUITT: found user in tee time)
 */
const updateArrayTeeTime = (teamsPlay, teeTimes, phone) => {
  const founderUser = teamsPlay
    ? teeTimes?.find((teeTime) =>
        teeTime.teams.find((team) =>
          team.users.find((teamUser) => teamUser.phone === phone),
        ),
      )
    : teeTimes?.find((teeTime) =>
        teeTime.users?.find((teamUser) => teamUser.phone === phone),
      );

  const { teamId } = teamsPlay
    ? founderUser?.teams.find((team) =>
        team.users.some((user) => user.phone === phone),
      ) || {}
    : {};

  const updatedArray = teeTimes?.map(
    (tt) =>
      tt && {
        ...tt,
        FUITT: tt === founderUser && !!founderUser,
        FUITT_ID: founderUser ? founderUser.id : "open",
        activeUserPlayingTeamId: teamId,
      },
  );

  return updatedArray;
};

function EventTeeTimes() {
  const navigation = useNavigate();
  const { eventId } = useParams();
  const event = useEvent(eventId);
  const teeTimes = useTeeTimes(eventId);

  const { info } = useContext(AlertContext);

  const { user } = useAuth();
  const userData = useUserData(user);

  const { phone } = userData ?? [];

  const {
    courseName,
    createdBy,
    teamsPlay,
    date,
    fiveSomes,
    matchType,
    title,
  } = event ?? {};

  const { lastName, firstName, profileImageUrl } = createdBy ?? {};

  const userTeeTime = findTeeTimeByUser(teeTimes, userData);

  const addUserInTeeTimeOrTeam2 = async ({ teamId, teeTimeId }) => {
    const checkSubmitted = isTeeTimeSubmitted(event, teeTimeId);

    if (checkSubmitted) {
      return navigation(`/event/${eventId}/finalScorecard`);
    }
    // eslint-disable-next-line no-unused-expressions
    return teamId
      ? navigation(`/event/${eventId}/${teeTimeId}/${teamId}/holes/booking`)
      : navigation(`/event/${eventId}/${teeTimeId}/holes/booking`);
  };

  const onOpenTeeTime = (teeTime, teamId) => {
    const { id, teeTime: targetTeeTimeTime } = teeTime;

    if (check2hourGap(targetTeeTimeTime)) {
      return teamId
        ? navigation(`/event/${eventId}/${id}/${teamId}/holes`)
        : navigation(`/event/${eventId}/${id}/holes`);
    }

    return info(
      // `The event is scheduled to start on ${formatFirestoreTimeStamp(
      //   targetTeeTimeTime,
      //   "EEE MMM dd",
      // )} at ${formatFirestoreTimeStamp(
      //   targetTeeTimeTime,
      //   "hh:mm a",
      // )}. The scorecard will be available 2 hours before the tee time.`,
      "tedt",
    );
  };

  return (
    <>
      <Header
        event={event}
        userData={userData}
        teeTime={userTeeTime}
        showTitle
        hideQr
      />
      <div style={{ backgroundColor: "#2977A4", padding: "20px 16px" }}>
        {/* <Text as="H2" bold ta="center" style={{ marginBottom: 12 }}>
          {teamsPlay ? "Join a PINZ teams match!" : "Join a PINZ match!"}
        </Text> */}
        <div
          style={{
            borderRadius: 16,
            display: "flex",
            flexDirection: "row",
            padding: "20px 16px",
            justifyContent: "space-between",
            backgroundColor: "white",
          }}
        >
          <EventDetails
            timestamp={date}
            courseName={courseName}
            profileImageUrl={profileImageUrl}
            firstName={firstName}
            lastName={lastName}
            title={title}
          />
        </div>
      </div>

      {teeTimes.length ? (
        <div className="pinz-invitation--wrapper">
          <div style={{ marginTop: 20 }}>
            {updateArrayTeeTime(teamsPlay, teeTimes, phone)?.map((teeTime) => {
              const teamSize = teamsPlay && teeTime.teams?.[0].teamSize;
              const {
                teeTimeString,
                users,
                teams,
                id: teeTimeId,
                FUITT,
                activeUserPlayingTeamId,
              } = teeTime;

              return (
                <CardEvent2
                  key={teeTimeId}
                  teamSize={teamSize}
                  teeTimeString={teeTimeString}
                  users={users}
                  teams={teams ?? false}
                  onJoinTeam={(teamId) =>
                    addUserInTeeTimeOrTeam2({ teamId, teeTimeId })
                  }
                  onJoinTeeTime={() => addUserInTeeTimeOrTeam2({ teeTimeId })}
                  isPlay={FUITT}
                  onOpenTeeTime={() =>
                    onOpenTeeTime(teeTime, activeUserPlayingTeamId)
                  }
                  findUserInTeeTime={teeTime.FUITT_ID === "open"}
                  sumbitted={isTeeTimeSubmitted(event, teeTimeId)}
                  alredyPlayInDifrentTeeTime={teeTime.FUITT_ID !== "open"}
                  fiveSomes={fiveSomes}
                  matchPlay={matchType === 3 || matchType === 8}
                />
              );
            })}
            {/* <ShareLink /> */}
            {Number.isNaN(Number(userData?.handicap)) && (
              <div
                style={{ padding: 10 }}
                onClick={() => navigation(`/event/${event.id}/auth`)}
                aria-hidden="true"
              >
                <Text
                  ta="center"
                  style={{
                    color: "gray",
                  }}
                  as="P1"
                >
                  The app seems to have forgotten you. Tap here to return
                </Text>
              </div>
            )}
          </div>
        </div>
      ) : (
        <EventTeeTimesSkeleton />
      )}
    </>
  );
}

export { EventTeeTimes };
